import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/streams/rules/inputs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
